// MobileContext.js
import React, { createContext, useContext } from "react";
import { isMobile } from "react-device-detect";

const MobileContext = createContext({ isMobile: false });

export const MobileProvider = ({ children }) => {
  return (
    <MobileContext.Provider value={{ isMobile }}>
      {children}
    </MobileContext.Provider>
  );
};

export const useMobile = () => useContext(MobileContext);
